import React, {useState} from 'react';
import './Message.scss';
import {timeAgo} from "../../../services/date_service";
import {AudioWaveform} from "../AudioWaveform/AudioWaveform ";
import {Languages} from 'lucide-react';

const Message = ({data}: any) => {

    const [showTranscript, setShowTranscript] = useState(false);
    const isVoice = data?.message_type === "voice_message" && data?.voice_message_url;

    return (
        <div className={`MessageBox ${data.message_sender === 'user' ? 'user' : ''}`}>
            {isVoice ? (
                <div className="Message Message--voice">
                    <AudioWaveform audioSrc={data?.voice_message_url}/>
                    {showTranscript && <h3>{data?.message}</h3>}
                </div>
            ) : (
                <div className="Message">
                    <h3>{data?.message}</h3>
                </div>
            )}

            <div className="MessageBox__meta">
                <span>{data.pending ? 'Sending…' : timeAgo(data.date)}</span>
                {
                    isVoice && <button type="button"
                                       className={`MessageBox__transcript ${showTranscript ? 'active' : ''}`}
                                       onClick={() => setShowTranscript(prevState => !prevState)}>
                        <Languages size={12}/> {showTranscript ? 'Hide text' : 'Show text'}
                    </button>
                }
            </div>
        </div>

    );
};

export default Message;
